import { render, staticRenderFns } from "./BIMApplication.vue?vue&type=template&id=21bef194&scoped=true&"
import script from "./BIMApplication.vue?vue&type=script&lang=js&"
export * from "./BIMApplication.vue?vue&type=script&lang=js&"
import style0 from "./BIMApplication.vue?vue&type=style&index=0&id=21bef194&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bef194",
  null
  
)

export default component.exports